/*
 * mod='download'
 * author: izzieyspu
 * time: 2020-02-09
 */

import { smb_fetch, getAgpApiUrl } from '../../../fetch';

const getApiUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act);

  return result;
};

// 获取离线下载任务列表
export const getDownloadTaskList = (data) => {
  const url = getApiUrl('async_task', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 获取离线下载文件
export const getDownloadFile = (data) => {
  const url = getApiUrl('async_task', 'download');
  const params = $.extend(
    true,
    {
      method: 'GET',
      loadingTip: '数据加载中，请稍后',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 创建离线下载任务
export const createDownloadTask = (data) => {
  const url = getApiUrl('async_task', 'create');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 获取离线下载文件
export const deleteDownloadTask = (data) => {
  const url = getApiUrl('async_task', 'delete');
  const params = $.extend(
    true,
    {
      method: 'POST',
      loadingTip: '任务删除中，请稍后',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 文件盖章
export const createStampReport = (data) => {
  const url = getApiUrl('async_task', 'seal');
  const params = $.extend(
    true,
    {
      method: 'POST',
      loadingTip: '创建盖章任务中，请稍后',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 日报下载列表
export const getDailyReportDownloadList = (data, isShowError = true) => {
  const url = getApiUrl('schedule_report', 'download_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError, false);
};

export default {
  getDownloadTaskList,
  getDownloadFile,
  createDownloadTask,
  deleteDownloadTask,
  createStampReport,
};
